import { useQueries } from '@tanstack/react-query';
import api from 'modules/queries/api';
import { VMWARE_VCLOUD_VDC_PORTAL_DETAILS_QUERY_KEY } from './usePortalDetails';

/**
 * The VM ids of several vDCs, keyed by vDC id. Shares its query key with
 * `useVmWareVCloudVdcPortalDetails`, so a vDC already viewed is served from the
 * cache.
 */
const useVmWareVCloudVdcPortalDetailsForVdcs = (
	uniqIds: string[],
	options?: { enabled?: boolean },
) => {
	const queries = useQueries({
		queries: uniqIds.map((uniqId) => ({
			queryKey: [
				VMWARE_VCLOUD_VDC_PORTAL_DETAILS_QUERY_KEY,
				{ uniq_id: uniqId },
			],
			queryFn: () =>
				api.vmWare.vCloud.vdc.apiRaw.portalDetails({ uniq_id: uniqId }),
			enabled: options?.enabled ?? true,
		})),
	});

	const vmIdsByVdcId: Record<string, string[]> = {};

	queries.forEach(({ data }, index) => {
		if (data) {
			vmIdsByVdcId[uniqIds[index]] = data.vms.map(
				({ uniq_id: vmUniqId }) => vmUniqId,
			);
		}
	});

	return {
		data: vmIdsByVdcId,
		isLoading: queries.some(({ isInitialLoading }) => isInitialLoading),
		isError: queries.some(({ isError }) => isError),
	};
};

export default useVmWareVCloudVdcPortalDetailsForVdcs;
